import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ReferenceService {
  constructor(private http: HttpClient) {}

  toggle<T>(url: string, dto: T): Observable<T> {
    return this.http.put<T>(url, dto);
  }
  create<T>(url: string, dto: T): Observable<T> {
    return this.http.post<T>(url, dto);
  }

  update<T>(url: string, oldId: string, dto: T): Observable<T> {
    return this.http.put<T>(url + `?id=${oldId}`, dto);
  }

  delete<T>(url: string, dto: T): Observable<T> {
    return this.http.post<T>(url, dto);
  }
}
